import React from "react";
import classNames from "../../classNames";

const modifiedBadgeStyle = {
  backgroundColor: "rgba(40, 55, 84, 0.12)",
  color: "var(--bs-primary, #283754)",
  fontSize: "0.7rem",
};

export default function PreviewFormModalRow({
  label,
  displayNew,
  displayOld,
  changed,
  isEmpty,
  isLast,
  isEditing,
  index,
}) {
  const isEven = index % 2 === 0;

  return (
    <div
      className={classNames(
        "d-flex justify-content-between align-items-start gap-3 px-3 py-2",
        isEven ? "bg-light" : "bg-white",
        changed && "border-start border-3 border-primary bg-white",
      )}
      style={{
        borderBottom: isLast ? undefined : "1px solid #dee2e6",
      }}
    >
      <span className="fw-semibold text-secondary small text-nowrap d-flex align-items-center gap-1">
        {label}
        {changed && isEditing ? (
          <span
            className="badge ms-1"
            style={modifiedBadgeStyle}
            title="This value was changed"
          >
            Modified
          </span>
        ) : (
          ""
        )}
        {!isEditing && !isEmpty && (
          <i
            className="bi bi-check-circle-fill text-success small"
            style={{ fontSize: "0.75rem" }}
            title="Unchanged"
            aria-hidden
          />
        )}
      </span>
      <span className="text-end text-break">
        {changed && isEditing ? (
          <span className="d-flex flex-column align-items-end gap-1 small">
            <span className="d-flex align-items-center gap-1">
              <span className="text-muted" style={{ fontSize: "0.7rem" }}>
                Previous:
              </span>
              <span className="text-decoration-line-through text-muted">
                {displayOld}
              </span>
            </span>
            <span className="d-flex align-items-center gap-1 fw-semibold text-primary">
              <span style={{ fontSize: "0.7rem" }}>New:</span>
              {displayNew}
            </span>
          </span>
        ) : (
          <span
            className={classNames(
              "fw-medium",
              isEmpty && "fst-italic text-muted",
            )}
          >
            {displayNew}
          </span>
        )}
      </span>
    </div>
  );
}
